import { FC } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { languageMenuHeight, languages } from "../hardCodeData";
import { changeLanguage } from "../../../utils/languageUtils";

interface props {
  headerHeight: string;
  openMenu: {
    language: boolean;
    carModels: boolean;
  };
}

const LanguageMenu: FC<props> = ({ openMenu, headerHeight }) => {
  const { i18n } = useTranslation();
  
  const handleLanguageChange = (lng: string) => {
    // Обновляем localStorage и URL
    changeLanguage(lng);
    // Меняем язык в i18n
    i18n.changeLanguage(lng);
  };

  return (
    <Box
      id="LanguageMenu"
      sx={{
        display: {xs: "none", md: "flex"},
        justifyContent: "end",
        height: openMenu.language ? languageMenuHeight : 0,
        transition: "ease-in-out 0.25s",
        width: "100%",
        background: "#fff",
        position: "fixed",
        top: headerHeight,
        overflow: "hidden",
        boxShadow: "0px 0px 15px -2px #000",
        "&:hover": {
          height: languageMenuHeight,
        },
        zIndex: 10,
      }}
    >
      {languages.map((language, i) => (
        <Box
          key={i}
          onClick={() => handleLanguageChange(language.lng)}
          sx={{
            px: 2,
            display: "flex",
            alignItems: "center",
            height: languageMenuHeight,
            fontWeight: 600,
            fontSize: "14px",
            color: i18n.resolvedLanguage === language.lng ? "#000" : "#555",
            transition: "ease-in-out 0.1s",
            "&:hover": {
              color: "#000",
              cursor: "pointer",
            },
          }}
        >
          <Box
            sx={{
              transition: "ease-in-out 0.25s",
              borderBottom: `1px rgba(0,0,0,${
                i18n.resolvedLanguage === language.lng ? 1 : 0
              }) solid`,
            }}
          >
            {language.name}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default LanguageMenu;
